import React from 'react';
import { ButtonSectionStyle } from './linkButtonSection.styles';

const LinkButtonSection = ({ children }) => {
  return <ButtonSectionStyle>{children}</ButtonSectionStyle>;
};

export default LinkButtonSection;
